import { Pipe, PipeTransform } from '@angular/core';
import { EmailSearchOrder } from 'src/app/types/enums/email.search-order';

@Pipe({
  name: 'formatSearchOrders',
  standalone: true,
})
export class FormatSearchOrders implements PipeTransform {
  transform(order: string): EmailSearchOrder {
    switch (order) {
      case 'date':
        return EmailSearchOrder.OrderBySentDateTime;
      case 'from':
        return EmailSearchOrder.OrderByFrom;
      case 'to':
        return EmailSearchOrder.OrderByTo;
      default:
        return EmailSearchOrder.OrderBySentDateTime;
    }
  }
}
